module.exports = __webpack_public_path__ + "img/prize-01.155821e9.png";